import { useEffect, useState } from "react"

import { create_keyword_string } from "./create_keyword_string"

export const useAdertisementData = ({
  place,
  adbutler_page_id,
  set_id,
  min_width,
  max_width,
  tags = [],
  topic = "",
  ressort,
}) => {
  const [state, setState] = useState({
    banner_id: "",
    body: "",
    imageURL: "",
    imageWidth: "",
    imageHeight: "",
    redirectURL: "",
    tracking_pixel: "",
    link_target: "",
    status: "",
  })

  const keyword_string = create_keyword_string({ tags, topic, ressort })

  useEffect(() => {
    if (
      (!min_width && !max_width) ||
      min_width <= window.innerWidth ||
      max_width >= window.innerWidth
    ) {
      fetch("https://api.ipify.org/?format=json", { method: "GET" })
        .then((ip_response) => ip_response.json())
        .then(({ ip }) => {
          fetch("https://servedbyadbutler.com/adserve", {
            method: "POST",
            body: JSON.stringify({
              ID: "169218",
              size: "0x0",
              setID: set_id,
              type: "json",
              pid: adbutler_page_id || undefined,
              place: !isNaN(place) ? place : undefined,
              kw: keyword_string || undefined,
              ip: ip,
            }),
          })
            .then((response) => response.json()) // parse JSON from request
            .then((resultData) => {
              if (resultData.status !== "NO_ADS") {
                setState({
                  banner_id: resultData?.placements?.placement_1.banner_id,
                  link_target: resultData?.placements?.placement_1.target,
                  body: resultData?.placements?.placement_1.body,
                  imageURL: resultData?.placements?.placement_1.image_url,
                  imageWidth: resultData?.placements?.placement_1.width,
                  imageHeight: resultData?.placements?.placement_1.height || "",
                  redirectURL: resultData?.placements?.placement_1.redirect_url,
                  tracking_pixel:
                    resultData?.placements?.placement_1.tracking_pixel,
                })
              } else {
                setState({ ...state, status: "NO_ADS" })
              }
            }) // set data for AD URL
        })
    } else {
      setState({ ...state, status: "NO_ADS" })
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}
